<template>
  <el-card class="list">
    <div slot="header">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{name: 'news'}">
          News
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="search">
        <fuzzy-search collection-name="news" :properties="['type', 'header', 'recipient', 'language']"></fuzzy-search>
        <el-button size="mini" @click="fetchAll">
          <i class="fa fa-refresh" aria-hidden="true"></i>
        </el-button>
      </div>
    </div>
    <paginator collection-name="news"></paginator>
    <el-table :data="news" style="width: 100%" border>
      <el-table-column prop="sent_date" label="SENT" sortable :formatter="dateFormatter"></el-table-column>
      <el-table-column prop="type" label="TYPE" sortable width="110"></el-table-column>
      <el-table-column prop="header" label="HEADER" sortable></el-table-column>
      <el-table-column prop="recipient" label="TO" sortable></el-table-column>
      <el-table-column prop="language" label="LANGUAGE" sortable></el-table-column>
      <el-table-column width="42" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click.prevent="details(scope.row.id)">
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    news () {
      return this.ids.map(id => this.entities[id])
    },
    ...mapState('news', {
      ids: state => state.paginator.ids,
      entities: state => state.entities,
      loaded: state => state.loaded
    })
  },

  methods: {
    details (id) {
      this.select(id)
      this.$router.push({ name: 'news/show', params: { id: id } })
    },
    dateFormatter (row, col) {
      return moment(row.sent_date).format('lll')
    },
    ...mapActions('news', {
      fetchAll: 'fetchAll',
      select: 'select'
    })
  },

  created () {
    if (!this.loaded) {
      this.fetchAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/News.vue